import { Injectable } from '@angular/core';
import { Network } from '@ionic-native/network/ngx';
import { Platform } from '@ionic/angular';
import { CommonDefinitionService } from '../common/common-definition.service';
import { CommonDeclarationService } from '../common/common-declaration.service';
import { HttpClient } from '@angular/common/http';

declare var navigator: any;
declare var Connection: any;

@Injectable({
  providedIn: 'root'
})
export class NetworkService {

  toastflg: any;
  constructor(public network: Network, public http: HttpClient, public platform: Platform, public cmndef: CommonDefinitionService, public cmndecl: CommonDeclarationService) {
    this.toastflg = 1;
    this.checkNewtwork();
    setInterval(() => {
      this.checkNewtwork();
      // this.checkbandwidth();
    }, 2000)
  }

  checkbandwidth() {
    var startTime;
    var imageAddr = "http://www.tranquilmusic.ca/images/cats/Cat2.JPG" + "?n=" + Math.random();
    var downloadSize = 5616998;
    var download = new Image();
    var _this = this;
    download.onload = function () {
      var endTime = (new Date()).getTime();
      _this.showResults(endTime, downloadSize, startTime);
    }
    startTime = (new Date()).getTime();
    download.src = imageAddr;
  }

  showResults(endTime, downloadSize, startTime) {
    var duration = (endTime - startTime) / 1000; //Math.round()
    var bitsLoaded = downloadSize * 8;
    var speedBps: any = (bitsLoaded / duration).toFixed(2);
    var speedKbps: any = (speedBps / 1024).toFixed(2);
    console.log("Your connection speed is: \n" + speedKbps + " kbps\n");
  }

  checkNewtwork() {
    this.platform.ready().then(async() => {
      try {
        if (window.navigator.onLine) {
          if (this.toastflg == 2) {
            this.toastflg = 1;
          }
          this.cmndecl.Networkstatus = true;
        }
        else {
          this.cmndecl.Networkstatus = false;
          if (this.toastflg == 1) {
            this.cmndecl.closeBankImg.next({"network": false});
            this.cmndef.Showtoast(this.cmndecl.LanguageJson.pages[0].alerts.unablenetwork);
            this.toastflg = 2;
          }
        }
      } catch (e) {
        console.log(e);
      }
    });
  }
}
